import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ParentHeader from "../parentHeader/ParentHeader";
import images from "../../utilities/images/images";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format, addDays, subDays } from "date-fns";
import uiActions from "../../redux/ui/action";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import "./StudentActivity.scss";
import { PARENT_STUDENT_ATTENDANCE_URL } from "../../../src/custom_utilities/baseURL";
import StudentActivityAttendance from "./dayWiseActivity/StudentActivityAttendance";
import LoaderPopUp from "../../components/loader/loader";
import StudentActivityContent from "./dayWiseActivity/StudentActivityContent";
import StudentActivityMonthly from "./monthlyActivity/StudentActivityMonthly";

function StudentActivity(props) {
  let { loginFromParent, loader } = props;

  const [activeTab, setActiveTab] = useState("day-wise");

  return (
    <>
      {loginFromParent && <ParentHeader />}
      <div className="student-activity-wrapper" >
        <div className="container">
          <div className="activity-wrapper">
      <div className="tabs-container-activity">
        <div className="tabs-activity">
          <button
            className={`tab ${activeTab === "day-wise" ? "active" : ""}`}
            onClick={() => setActiveTab("day-wise")}
          >
            Day-wise Activity
          </button>
          <button
            className={`tab ${activeTab === "monthly" ? "active" : ""}`}
            onClick={() => setActiveTab("monthly")}
          >
            Monthly Activity
          </button>
        </div>
      </div>
      <div className="tab-content">
        {activeTab === "day-wise" ? (
          <StudentActivityContent />
        ) : (
          <StudentActivityMonthly />
        )}
      </div>
      </div></div></div>

      {loader && <LoaderPopUp />}
    </>
  );
}

const mapStateToProps = (state) => {
  // console.log("state.auth.user.roll_no", state.auth);
  return {
    loader: state.ui.loader,
    rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
    loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(StudentActivity);
